/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useDocumentStore = defineStore("document", {
  actions: {
    async uploadFetch(payload) {
      let body;
      if (payload instanceof FormData) {
        body = payload;
      } else if (payload && payload.formdata instanceof FormData) {
        body = payload.formdata;
      } else if (payload && payload.formdata) {
        body = payload.formdata;
      } else {
        const formData = new FormData();
        formData.append("forGroupUid", payload?.forGroupUid ?? "");
        formData.append("forShopUid", payload?.forShopUid ?? "");
        formData.append(
          "publicAccess",
          payload?.publicAccess !== undefined ? payload.publicAccess : false
        );

        if (payload?.files) {
          if (
            Array.isArray(payload.files) ||
            (typeof FileList !== "undefined" &&
              payload.files instanceof FileList)
          ) {
            for (let i = 0; i < payload.files.length; i++) {
              formData.append("files", payload.files[i]);
            }
          } else {
            formData.append("files", payload.files);
          }
        } else if (payload?.file) {
          formData.append("files", payload.file);
        }

        body = formData;
      }

      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/upload";
          const response = http.post(pathUrl, body, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async getinfoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/info";
          const response = http.post(pathUrl, payload); // สั่งแบบ json ปกติ ไม่ต้องระบุ blob
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async getFileFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          // 🟢 1. เปลี่ยนพาร์ท URL เป็นตัดเลขไอดีที่ต่อท้ายออก (เพราะจะส่งผ่าน body แทน)
          const pathUrl = "/doc-svc/document/file";

          // 🟢 2. เปลี่ยนเป็น http.post ส่ง payload และบังคับรับเป็น blob เสมอ
          const response = http.post(pathUrl, payload, {
            responseType: 'blob'
          });

          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async addFetch(payload) {
      const body = {
        name: payload.name,
        data: payload.data,
        forGroupUid: "", // required for platform user, assign this document to which group
        forShopUid: "", // required for platform user, assign this document to wihic shop
        publicAccess: true, // required for platform user, this document is public for all shops
        mimeType: payload.mimeType,
      };
      // console.log("addFetch : " + JSON.stringify(body));
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async updateFetch(payload) {
      const body = {
        uid: payload.uid,
        name: payload.name,
        mimeType: payload.mimeType,
        data: payload.data,
        forGroupUid: "",
        forShopUid: "",
        publicAccess: true,
        version: payload.version,
      };
      // console.log("updateFetch : " + JSON.stringify(body));
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/update";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async deleteFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/delete/" + payload.uid;
          const response = http.delete(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async imgAdminInfoFetch(payload) {
      const body = {
        uid: payload.uid,
        shopUid: payload.shopUid,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/admin/info";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async deleteTkImgFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl =
            "/pawn-svc/ticket/image/delete/" +
            payload.shopUid +
            "/" +
            payload.uid;
          const response = http.delete(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
